export const ROUTES = {
  HOME: '/',
  EXTERNAL: '/external',
  QUOTATIONS: {
    CREATE: '/quotations/create',
    UPDATE: (id = ':id') => `/quotations/${id}/update`,
    PLANS: {
      LIST: (id = ':id') => `/quotations/${id}/plans`,
      COMPARISON: (id = ':id') => `/quotations/${id}/plans/comparison`,
    },
  },
  ADMIN_PANEL: '/admin-panel',
  AUTO_FORM: '/admin-panel/formulario-autos',
  AGREEMENTS: {
    CREATE: '/agreements/create',
    VIEW: (id = ':id') => `/agreements/${id}`,
    UPDATE: (id = ':id') => `/agreements/${id}/update`,
  },
  NOT_FOUND: '*',
};